import { PRESET_OPTIONS } from "@/cms/useSpacing";

const SECTIONS = [
  { id: "sobre", label: "Sobre" },
  { id: "servicos", label: "Serviços" },
  { id: "portfolio", label: "Portfolio" },
  { id: "testemunhos", label: "Testemunhos" },
  { id: "contacto", label: "Contacto" },
];

const Select = ({ label, value, onChange, options, testid, placeholder = "—" }) => (
  <label className="flex flex-col gap-2">
    <span className="overline text-[#6B6554]">{label}</span>
    <select
      data-testid={testid}
      className="ordo-field"
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="">{placeholder}</option>
      {options.map((o) => (
        <option key={o.value} value={o.value}>{o.label}</option>
      ))}
    </select>
  </label>
);

const Toggle = ({ label, value, onChange, testid }) => (
  <label className="flex items-center gap-3 cursor-pointer select-none">
    <button
      type="button"
      data-testid={testid}
      onClick={() => onChange(!value)}
      className={`relative w-11 h-6 rounded-full transition-colors ${value ? "bg-[#3A3524]" : "bg-[#3A3524]/25"}`}
      aria-pressed={!!value}
    >
      <span className={`absolute top-0.5 left-0.5 w-5 h-5 rounded-full bg-[#F5F2EC] transition-transform ${value ? "translate-x-5" : ""}`} />
    </button>
    <span className="text-[#3A3524] text-sm">{label}</span>
  </label>
);

const SpacingPanel = ({ data, patch }) => {
  return (
    <section data-testid="admin-spacing" className="flex flex-col gap-10 max-w-4xl">
      <div className="font-serif italic text-[#6B6554] text-lg leading-relaxed">
        Ajusta o espaçamento de cada secção. "Deixar em branco" mantém o padrão actual.
      </div>

      <div>
        <div className="overline text-[#8C714D] mb-6">Divisórias entre secções</div>
        <Toggle
          testid="spacing-dividers"
          label="Mostrar linhas divisórias entre secções"
          value={data.spacing?.dividers !== false}
          onChange={(v) => patch("spacing.dividers", v)}
        />
      </div>

      {SECTIONS.map((s) => (
        <div key={s.id} className="border-t border-[#3A3524]/12 pt-8">
          <div className="font-serif italic text-2xl text-[#3A3524] mb-5">{s.label}</div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-4">
            <Select
              testid={`spacing-py-${s.id}`}
              label="Espaço em cima e em baixo (secção)"
              value={data.spacing?.py?.[s.id]}
              onChange={(v) => patch(`spacing.py.${s.id}`, v)}
              options={PRESET_OPTIONS.py}
              placeholder="Normal (padrão)"
            />
            <Select
              testid={`spacing-overline-${s.id}`}
              label="Espaço overline → título"
              value={data.spacing?.overlineGap?.[s.id]}
              onChange={(v) => patch(`spacing.overlineGap.${s.id}`, v)}
              options={PRESET_OPTIONS.overlineGap}
              placeholder="Padrão"
            />
            <Select
              testid={`spacing-title-${s.id}`}
              label="Espaço título → texto"
              value={data.spacing?.titleGap?.[s.id]}
              onChange={(v) => patch(`spacing.titleGap.${s.id}`, v)}
              options={PRESET_OPTIONS.titleGap}
              placeholder="Padrão"
            />
          </div>
        </div>
      ))}
    </section>
  );
};

export default SpacingPanel;
